module.exports = __webpack_public_path__ + "static/media/19ESCAP27.d2c2daa2.jpg";